
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import { WorkstationDocument } from '@/api/types/workstation'
import Logo from '@/components/icons/Logo.vue'
import RIcon from '@/components/icons/index.vue'
import RBadge from '@/components/wizard/RBadge.vue'
import HelpContextMenu from '@/components/platform/HelpContextMenu.vue'
import UserContextMenu from '@/components/platform/UserContextMenu.vue'
import CapacityErrorModal from '@/components/modals/CustomTextModalCapacityError.vue'

import { AwsRegion } from '@/api/types/user'

import TrialBanner from '@/components/banners/TrialBanner.vue'
import CustomPlanBanner from '@/components/banners/CustomPlanBanner.vue'

import { getTrialBannerStatus, customBundlesCodenames } from '@/services/bundles'

export default Vue.extend({
  name: 'Dashboard',
  components: {
    Logo,
    RIcon,
    RBadge,
    HelpContextMenu,
    UserContextMenu,
    CapacityErrorModal,
    TrialBanner,
    CustomPlanBanner,
  },
  computed: {
    pages() {
      const dashboardPages = [
        { name: 'Dashboard', path: '/dashboard', icon: 'Dashboard' },
        { name: 'Computers', path: '/computers', icon: 'Workstation' },
        { name: 'Drives', path: '/drives', icon: 'Drive' },
        { name: 'Teams', path: '/teams', icon: 'Teams' },
        { name: 'Logs and stats', path: '/activity', icon: 'Rates' },
      ]
      return dashboardPages
    },
    trialStatus(): string | null {
      return getTrialBannerStatus(this.trialEndSecondsTimestamp, this.credits)
    },
    shouldShowCustomPlanBanner(): boolean {
      const found = customBundlesCodenames.find(
        (customCodename: string) => customCodename === this.selectedTier?.codename,
      )
      return Boolean(found)
    },
    shouldShowTeradiciBanner(): boolean {
      return true
    },
    ...mapGetters({
      displayName: 'user/displayName',
      photoURL: 'user/photoURL',
      isRenderroAdmin: 'user/isRenderroAdmin',
      hasTeamsEnabled: 'user/hasTeamsEnabled',
      lastNotification: 'notification/lastNotification',
      region: 'user/userRegion',
      trialEndSecondsTimestamp: 'user/trialEndSecondsTimestamp',
      credits: 'payment/creditsInCents',
      workstations: 'workstation/workstations',
      //customPlanBanner
      selectedTier: 'user/selectedTier',
    }),
  },
  methods: {
    showCapacityErrorModalForRegion(region: AwsRegion | 'all'): boolean {
      return (
        this.lastNotification?.type === 'error' &&
        this.lastNotification?.text.code === 'resource-exhausted' &&
        this.region === (region || 'all')
      )
    },
    ...mapActions({
      refreshCredits: 'payment/refreshCredits',
    }),
  },
  watch: {
    lastNotification() {
      if (this.showCapacityErrorModalForRegion('eu-central-1')) {
        this.$rModal.show('capacity-error')
      }
    },
    /**
     * Refresh credits on workstation stop
     */
    workstations(newWorkstations, oldWorkstations) {
      if (oldWorkstations == null || !oldWorkstations.length || !newWorkstations == null) return
      const oldNumberOfStopped = oldWorkstations.filter(
        (ws: WorkstationDocument) => ws.status == 'stopped',
      ).length
      const newNumberOfStopped = newWorkstations.filter(
        (ws: WorkstationDocument) => ws.status == 'stopped',
      ).length
      if (newNumberOfStopped > oldNumberOfStopped) {
        this.refreshCredits()
      }
    },
  },
})
